/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Problem_HeadlineInputs */

const en_problem_headline = /** @type {(inputs: Problem_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You've probably saved tons of articles and long videos you keep meaning to get to`)
};

const de_problem_headline = /** @type {(inputs: Problem_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestimmt hast du auch jede Menge Artikel und Videos gespeichert, die du noch lesen willst`)
};

const zh_tw_problem_headline = /** @type {(inputs: Problem_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相信你也存了很多好文章跟長影片，一直想找時間看完`)
};

const zh_cn_problem_headline = /** @type {(inputs: Problem_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相信你也存了很多好文章和长视频，一直想找时间看完`)
};

const es_problem_headline = /** @type {(inputs: Problem_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seguro tú también tienes artículos y videos guardados que siempre quieres ver`)
};

const fr_problem_headline = /** @type {(inputs: Problem_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu as sûrement plein d'articles et de longues vidéos en attente que tu n'as jamais le temps de regarder`)
};

const it_problem_headline = /** @type {(inputs: Problem_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scommetto che anche tu hai salvato articoli e video lunghi che vorresti finire`)
};

const pt_br_problem_headline = /** @type {(inputs: Problem_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aposto que você também tem vários artigos e vídeos salvos esperando o momento certo`)
};

const ja_problem_headline = /** @type {(inputs: Problem_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`気になる記事や長い動画、「あとで見よう」と思ったまま溜まっていませんか`)
};

const ko_problem_headline = /** @type {(inputs: Problem_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`좋은 글이나 긴 영상, 나중에 보려고 저장해둔 거 꽤 많지 않나요?`)
};

const ru_problem_headline = /** @type {(inputs: Problem_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Наверняка у тебя тоже скопились статьи и длинные видео, до которых всё никак не дойдут руки`)
};

const th_problem_headline = /** @type {(inputs: Problem_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เชื่อว่าคุณก็เก็บบทความดีๆ กับคลิปยาวๆ ไว้เยอะ แต่ยังไม่ได้ดูสักที`)
};

const tr_problem_headline = /** @type {(inputs: Problem_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eminim senin de okumak isteyip bir türlü vakit bulamadığın yazılar ve videolar vardır`)
};

const ar_problem_headline = /** @type {(inputs: Problem_HeadlineInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بالتأكيد لديك مقالات وفيديوهات طويلة محفوظة، تنتظر الوقت المناسب لها`)
};

/**
* | output |
* | --- |
* | "You've probably saved tons of articles and long videos you keep meaning to get to" |
*
* @param {Problem_HeadlineInputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const problem_headline = /** @type {((inputs?: Problem_HeadlineInputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Problem_HeadlineInputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_problem_headline(inputs)
	if (locale === "de") return de_problem_headline(inputs)
	if (locale === "zh_tw") return zh_tw_problem_headline(inputs)
	if (locale === "zh_cn") return zh_cn_problem_headline(inputs)
	if (locale === "es") return es_problem_headline(inputs)
	if (locale === "fr") return fr_problem_headline(inputs)
	if (locale === "it") return it_problem_headline(inputs)
	if (locale === "pt_br") return pt_br_problem_headline(inputs)
	if (locale === "ja") return ja_problem_headline(inputs)
	if (locale === "ko") return ko_problem_headline(inputs)
	if (locale === "ru") return ru_problem_headline(inputs)
	if (locale === "th") return th_problem_headline(inputs)
	if (locale === "tr") return tr_problem_headline(inputs)
	return ar_problem_headline(inputs)
});